import React from 'react'
import MorningIcon from '../../../../../../Assets/Images/icons/newIcons/morningIcon'
import LunchIcon from '../../../../../../Assets/Images/icons/newIcons/lunchIcon'
import AfternoonIcon from '../../../../../../Assets/Images/icons/newIcons/afternoonIcon'
import { TIME_SLOTS } from '../../../options'
import { WEATHER_CONDITIONS } from '../../../../../../Utils/Weather'
import ClearIcon from 'Assets/Images/icons/weather/ClearIcon'
import RainIcon from 'Assets/Images/icons/weather/RainIcon'
import PartiallyCloudyIcon from 'Assets/Images/icons/weather/PartiallyCloudyIcon'
import OvercastIcon from 'Assets/Images/icons/weather/OvercastIcon'
import ThunderRainIcon from 'Assets/Images/icons/weather/ThunderRainIcon'
import HailIcon from 'Assets/Images/icons/weather/HailIcon'
import TornadoIcon from 'Assets/Images/icons/weather/TornadoIcon'
import HurricaneIcon from 'Assets/Images/icons/weather/HurricaneIcon'
import RainPartiallyCloudyIcon from 'Assets/Images/icons/weather/RainPartiallyCloudyIcon'
import SnowIcon from 'Assets/Images/icons/weather/SnowIcon'
import SleetIcon from 'Assets/Images/icons/weather/SleetIcon'
import FogIcon from 'Assets/Images/icons/weather/FogIcon'
import HazeIcon from 'Assets/Images/icons/weather/HazeIcon'
import DrizzleIcon from 'Assets/Images/icons/weather/DrizzleIcon'
import DustIcon from 'Assets/Images/icons/weather/DustIcon'
import WindIcon from 'Assets/Images/icons/weather/WindIcon'
import ThunderStormIcon from 'Assets/Images/icons/weather/ThunderstormIcon'
import SmokeIcon from 'Assets/Images/icons/weather/SmokeIcon'

const transformMultipleConditionsToIcon = (conditions, style) => {
  if (!conditions) {
    return '-'
  }
  if (conditions.includes(WEATHER_CONDITIONS.SNOW)) {
    return <SnowIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.RAIN)) {
    return <RainIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.SLEET)) {
    return <SleetIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.THUNDERSTORM)) {
    return <ThunderStormIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.THUNDER_RAIN)) {
    return <ThunderRainIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.HAIL)) {
    return <HailIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.TORNADO)) {
    return <TornadoIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.HURRICANE)) {
    return <HurricaneIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.FOG)) {
    return <FogIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.FOG_PARTIALLY_CLOUDY)) {
    return <HazeIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.HAZE)) {
    return <HazeIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.MIST)) {
    return <FogIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.DRIZZLE)) {
    return <DrizzleIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.SHOWERS)) {
    return <DrizzleIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.SMOKE)) {
    return <SmokeIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.RAIN_PARTIALLY_CLOUDY)) {
    return <RainPartiallyCloudyIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.RAIN_OVERCAST)) {
    return <RainIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.SNOW_RAIN_OVERCAST)) {
    return <SnowIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.SNOW_OVERCAST)) {
    return <SnowIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.SNOW_PARTIALLY_CLOUDY)) {
    return <SnowIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.OVERCAST)) {
    return <OvercastIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.PARTIALLY_CLOUDY)) {
    return <PartiallyCloudyIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.DUST)) {
    return <DustIcon style={style} />
  }
  if (conditions.includes(WEATHER_CONDITIONS.WIND)) {
    return <WindIcon style={style} />
  }
  return '-'
}

export const getWeatherIcon = condition => {
  const style = {
    width: '30px',
    height: '30px',
  }
  switch (condition) {
    case WEATHER_CONDITIONS.CLEAR:
      return <ClearIcon style={style} />
    case WEATHER_CONDITIONS.PARTIALLY_CLOUDY:
      return <PartiallyCloudyIcon style={style} />
    case WEATHER_CONDITIONS.OVERCAST:
      return <OvercastIcon style={style} />
    case WEATHER_CONDITIONS.RAIN:
      return <RainIcon style={style} />
    case WEATHER_CONDITIONS.RAIN_PARTIALLY_CLOUDY:
      return <RainPartiallyCloudyIcon style={style} />
    case WEATHER_CONDITIONS.RAIN_OVERCAST:
      return <RainIcon style={style} />
    case WEATHER_CONDITIONS.SNOW:
      return <SnowIcon style={style} />
    case WEATHER_CONDITIONS.SLEET:
      return <SleetIcon style={style} />
    case WEATHER_CONDITIONS.FOG:
      return <FogIcon style={style} />
    case WEATHER_CONDITIONS.FOG_PARTIALLY_CLOUDY:
      return <HazeIcon style={style} />
    case WEATHER_CONDITIONS.HAZE:
      return <HazeIcon style={style} />
    case WEATHER_CONDITIONS.MIST:
      return <FogIcon style={style} />
    case WEATHER_CONDITIONS.DRIZZLE:
      return <DrizzleIcon style={style} />
    case WEATHER_CONDITIONS.SHOWERS:
      return <DrizzleIcon style={style} />
    case WEATHER_CONDITIONS.DUST:
      return <DustIcon style={style} />
    case WEATHER_CONDITIONS.WIND:
      return <WindIcon style={style} />
    case WEATHER_CONDITIONS.THUNDERSTORM:
      return <ThunderStormIcon style={style} />
    case WEATHER_CONDITIONS.THUNDER_RAIN:
      return <ThunderRainIcon style={style} />
    case WEATHER_CONDITIONS.HAIL:
      return <HailIcon style={style} />
    case WEATHER_CONDITIONS.TORNADO:
      return <TornadoIcon style={style} />
    case WEATHER_CONDITIONS.HURRICANE:
      return <HurricaneIcon style={style} />
    case WEATHER_CONDITIONS.SMOKE:
      return <SmokeIcon style={style} />
    case WEATHER_CONDITIONS.SNOW_RAIN_OVERCAST:
      return <SnowIcon style={style} />
    case WEATHER_CONDITIONS.SNOW_OVERCAST:
      return <SnowIcon style={style} />
    case WEATHER_CONDITIONS.SNOW_PARTIALLY_CLOUDY:
      return <SnowIcon style={style} />
    default:
      return transformMultipleConditionsToIcon(condition, style)
  }
}

export const getTimeIcon = timeSlot => {
  switch (timeSlot) {
    case TIME_SLOTS.MORNING:
      return <MorningIcon />
    case TIME_SLOTS.LUNCH:
      return <LunchIcon />
    case TIME_SLOTS.AFTERNOON:
      return <AfternoonIcon />
    default:
      return null
  }
}
